import type { BuildingGraphVolumeEdge } from "building-types/building/buildingGraphTypes";
import type { BuildingGraphFilterBuilding } from "building-types/buildingGraphFilter/buildingGraphFilterBuilding";
import type { PropertyPath } from "building-types/buildingGraphFilter/propertyCatalog";
import { assertUnreachable } from "common/utils/assertUnreachable";
import { volumeEdgeGetPlaneHashes } from "../entityFilterSelectors";
import type { EntityFilterSource, PropertyDescriptorForPath, PropertyValue } from "../entityFilterSourceTypes";

const VOLUME_EDGE_DESCRIPTORS: { [P in PropertyPath<"VOLUME_EDGE">]: PropertyDescriptorForPath<"VOLUME_EDGE", P> } = {
  volumeEdgeId: { kind: "SCALAR", type: "id" },
  volumeANodeId: { kind: "SCALAR", type: "id" },
  volumeBNodeId: { kind: "SCALAR", type: "id" },
  planeHashes: { kind: "SET", type: "string" },
};

function readVolumeEdgeProperty(
  volumeEdge: BuildingGraphVolumeEdge,
  path: PropertyPath<"VOLUME_EDGE">,
  building: BuildingGraphFilterBuilding,
): PropertyValue {
  switch (path) {
    case "volumeEdgeId":
      return { kind: "SCALAR", value: volumeEdge.volumeEdgeId };
    case "volumeANodeId":
      return { kind: "SCALAR", value: volumeEdge.volumeANodeId };
    case "volumeBNodeId":
      return { kind: "SCALAR", value: volumeEdge.volumeBNodeId };
    case "planeHashes":
      return { kind: "SET", values: volumeEdgeGetPlaneHashes(volumeEdge, building) };
    default:
      return assertUnreachable(path);
  }
}

export const volumeEdgeSource: EntityFilterSource<"VOLUME_EDGE"> = {
  sourceId: "VOLUME_EDGE",
  *iterateRows(building) {
    for (const volumeEdge of building.buildingGraph.volumeEdges) {
      if (volumeEdge) {
        yield volumeEdge;
      }
    }
  },
  identity(volumeEdge) {
    return volumeEdge.volumeEdgeId;
  },
  descriptor(path) {
    return VOLUME_EDGE_DESCRIPTORS[path];
  },
  readProperty(volumeEdge, path, building) {
    return readVolumeEdgeProperty(volumeEdge, path, building);
  },
};
